import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-profile-biography',
  templateUrl: './profile-biography.component.html',
  styleUrls: ['./profile-biography.component.scss']
})
export class ProfileBiographyComponent implements OnInit {
  @Input() biography = new BehaviorSubject<string>(null);

  constructor() { }

  ngOnInit(): void {
  }

}
